export default __webpack_public_path__ + "static/media/settings.f0f38d46.svg";